// import { useEffect, useRef } from "react";

// export function useVideoKeyboardControls({ videoRewind, videoForward }) {
//     // Keep latest callbacks in refs
//     const rewindRef = useRef(videoRewind);
//     const forwardRef = useRef(videoForward);

//     useEffect(() => {
//         rewindRef.current = videoRewind;
//     }, [videoRewind]);

//     useEffect(() => {
//         forwardRef.current = videoForward;
//     }, [videoForward]);

//     useEffect(() => {
//         const handleKeyDown = (event) => {
//             if (event.key === "ArrowLeft") {
//                 rewindRef.current?.();
//             } else if (event.key === "ArrowRight") {
//                 forwardRef.current?.();
//             }
//         };

//         window.addEventListener("keydown", handleKeyDown);
//         return () => {
//             window.removeEventListener("keydown", handleKeyDown);
//         };
//     }, []);
// }


// import { useEffect, useRef } from "react";

// export function useVideoKeyboardControls({ videoRewind, videoForward }) {
//     const rewindRef = useRef(videoRewind);
//     const forwardRef = useRef(videoForward);
//     // const toggleRef = useRef(togglePlay);

//     useEffect(() => { rewindRef.current = videoRewind; }, [videoRewind]);
//     useEffect(() => { forwardRef.current = videoForward; }, [videoForward]);
//     // useEffect(() => { toggleRef.current = togglePlay; }, [togglePlay]);

//     useEffect(() => {
//         const handleKeyDown = (event) => {
//             if (event.key === "ArrowLeft") {
//                 rewindRef.current?.();
//             } else if (event.key === "ArrowRight") {
//                 forwardRef.current?.();
//             } else if (event.code === "Space") {
//                 event.preventDefault(); // prevent page scroll
//                 // toggleRef.current?.();
//             }
//         };

//         window.addEventListener("keydown", handleKeyDown);
//         return () => {
//             window.removeEventListener("keydown", handleKeyDown);
//         };
//     }, []);
// }


import { useEffect, useRef } from "react";

export function useVideoKeyboardControls({ videoRewind, videoForward }) {
    const rewindRef = useRef(videoRewind);
    const forwardRef = useRef(videoForward);

    useEffect(() => { rewindRef.current = videoRewind; }, [videoRewind]);
    useEffect(() => { forwardRef.current = videoForward; }, [videoForward]);

    useEffect(() => {
        let intervalId = null;

        const handleKeyDown = (event) => {
            if (event.repeat) return; // ignore auto-repeat from OS

            if (event.key === "ArrowLeft") {
                intervalId = setInterval(() => rewindRef.current?.(), 200); // step every 200ms
            } else if (event.key === "ArrowRight") {
                intervalId = setInterval(() => forwardRef.current?.(), 200);
            } else if (event.code === "Space") {
                event.preventDefault();
                // toggle play/pause if needed
            }
        };

        const handleKeyUp = (event) => {
            if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
                clearInterval(intervalId);
                intervalId = null;
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("keyup", handleKeyUp);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("keyup", handleKeyUp);
            if (intervalId) clearInterval(intervalId);
        };
    }, []);
}
